/* unplugin-vue-components disabled */import script from "./OrderDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./OrderDrawer.vue?vue&type=style&index=0&id=1b66c622&scoped=true&lang=less"
import "./OrderDrawer.vue?vue&type=style&index=1&id=1b66c622&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b66c622"]])

export default __exports__